















































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import {Getter, Mutation, State} from "vuex-class";
import { ReplaceRoute } from '../../types/store';
import Axios from "axios";
import alzuhudLink from "@/components/Functions/Functions";

@Component({
    data: () => ({
        date: '',
        date2: '',
        // files: null
    })
})
export default class FillInformation extends Vue {
    menu: boolean = false;
    menu2: boolean = false;
    // @ts-ignore
    file: File = null;
    // @ts-ignore
    file2: File = null;
    @Mutation replaceRoute: ReplaceRoute;
    @Mutation setPage: Function;
    @State numAdults: any;
    @State numChildren: any;
    @State numNights: any;
    @State remarks: any;
    @State countries: any[];
    @Mutation setNumAdults: Function;
    @Mutation setNumChildren: Function;
    @Mutation setNumNights: Function;
    @Mutation setRemarks: Function;
    @Getter totalPrice: any;
    @State adults: any[];
    @State children: any[];
    @State country: any;
    @Mutation setAdults: Function;
    @Mutation setChildren: Function;
    @Mutation setCountry: Function;
    numNightsList: number[] = [];
    localAdults: any[] = [];
    localChildren: any[] = [];
    email: string = '';
    @State bookingName: string;
    @State bookingPhone: string;
    @Mutation setBookingName: Function;
    @Mutation setBookingPhone: Function;
    @Getter token: string;
    @State isPriceApplied: any;
    @Watch('localChildren')
    updateChildren() {
        this.setChildren(this.localChildren);
    }

    @Watch('localAdults')
    updateAdults() {
        this.setAdults(this.localAdults);
    }

    allowedDates (val: any) {
        return new Date(val) <= new Date();
    };

    async mounted() {
        this.replaceRoute(['Booking', 'Reserve', 'Create Package', 'Information']);
        this.setPage(2);
        this.numNightsList = new Array(20).fill(0).map((item, index) => index + 1);
        // this.setNumAdults(1);
        // this.setNumChildren(0);
        if (this.numAdults !== 0) {
            for (let i = 0; i < this.numAdults; i++) {
                this.localAdults.push(this.adults[i]);
            }
        } else {
            this.setNumAdults(1);
            this.localAdults.push({
                full_name: '',
                file: null,
                gender: '',
                date: '',
                menu: false,
            })
        }

        for (let i = 0; i < this.numChildren; i++) {
            this.localChildren.push(this.children[i]);
        }

        try {
            const response = await Axios.get(`http://${alzuhudLink}:8080/api/auth/me`, {
                params: {
                    token: this.token,
                }
            })

            this.Name = response.data.full_name;
            this.Phone = response.data.phone;
            this.email = response.data.email;
        } catch(e) {

        }

        // setInterval(() => {
        //     this.setAdults(this.localAdults);
        // }, 0);
        //
        // setInterval(() => {
        //     this.setChildren(this.localChildren);
        // }, 0);
    }

    split(str: string): string {
        let strData = parseFloat(str);
        let data = strData.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        return data.split('.')[0];
    }

    private get selectedCountry(): any {
        return this.country;
    }

    private set selectedCountry(val: any) {
        this.setCountry(val);
    }

    get NumNights(): any {
        return this.numNights;
    }
    set NumNights(val: any) {
        this.setNumNights(val);
    }
    get NumAdults(): any {
        return this.numAdults;
    }
    set NumAdults(val: any) {
        if (0 < val && val <= 20) {
            if (val > this.numAdults) {
                for (let i = 0; i < Math.abs(val - this.numAdults); i++) {
                    this.localAdults.push({
                        full_name: '',
                        file: null,
                        gender: '',
                        date: '',
                        menu: false,
                    });
                }
            } else {
                for (let i = 0; i < Math.abs(val - this.numAdults); i++) {
                    this.localAdults.pop();
                }
            }
            this.setNumAdults(parseInt(val));
        }
        else {
            const val1 = this.numAdults;
            this.setNumAdults(0);
            setTimeout(() => {
                this.setNumAdults(val1);
            }, 10);
        }
        this.$forceUpdate();
    }

    get NumChildren(): any {
        return this.numChildren;
    }
    set NumChildren(val: any) {
        if (0 <= val && val <= 20) {
            if (val > this.numChildren) {
                for (let i = 0; i < Math.abs(parseInt(val) - this.numChildren); i++) {
                    this.localChildren.push({
                        full_name: '',
                        file: null,
                        gender: '',
                        date: '',
                        menu: false,
                    });
                }
            } else {
                for (let i = 0; i < Math.abs(parseInt(val) - this.numChildren); i++) {
                    this.localChildren.pop();
                }
            }
            this.setNumChildren(parseInt(val));
        }
        else {
            const val1 = this.numAdults;
            this.setNumChildren(0);
            setTimeout(() => {
                this.setNumChildren(val1);
            }, 10);
        }
        this.$forceUpdate();
    }

    get Remarks(): any {
        return this.remarks;
    }
    set Remarks(val: any) {
        this.setRemarks(val);
    }

    selectFile(num: number): void {
        let el: HTMLElement | null = null;
        el = document.getElementById(`file-input-${num}`);
        if (el !== null) {
            el.click();
        }
    }

    order(i: number): string {
        if (i === 11 || i === 12 || i === 13) {
            return i+'th';
        }
        switch (i % 10) {
            case 1:
                return i+'st';
            case 2:
                return i+'nd';
            case 3:
                return i+'rd';
            default:
                return i+'th';
        }
    }

    get Name(): any {
        return this.bookingName;
    }
    set Name(val: any) {
        this.setBookingName(val);
    }

    get Phone(): any {
        return this.bookingPhone;
    }
    set Phone(val: any) {
        this.setBookingPhone(val);
    }

    isNumber(evt: Event | undefined) {
        evt = (evt) ? evt : window.event;
        // @ts-ignore
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            // @ts-ignore
            evt.preventDefault();
        } else {
            return true;
        }
    }

    beforeDestroy() {
        this.setAdults(this.localAdults);
        this.setChildren(this.localChildren);
    }
}
